module.exports = __webpack_public_path__ + "images/emoji/cancer.ea8c380dbb70a38f1b07.png";